"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaptchaDataToJSON = exports.CaptchaDataFromJSONTyped = exports.CaptchaDataFromJSON = void 0;
var _1 = require("./");
function CaptchaDataFromJSON(json) {
    return CaptchaDataFromJSONTyped(json, false);
}
exports.CaptchaDataFromJSON = CaptchaDataFromJSON;
function CaptchaDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'imageUrl': json['imageUrl'],
        'audio': (0, _1.CaptchaDataAudioFromJSON)(json['audio']),
        'fieldName': json['fieldName'],
        'actionUrl': json['actionUrl'],
    };
}
exports.CaptchaDataFromJSONTyped = CaptchaDataFromJSONTyped;
function CaptchaDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'imageUrl': value.imageUrl,
        'audio': (0, _1.CaptchaDataAudioToJSON)(value.audio),
        'fieldName': value.fieldName,
        'actionUrl': value.actionUrl,
    };
}
exports.CaptchaDataToJSON = CaptchaDataToJSON;
//# sourceMappingURL=CaptchaData.js.map